import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import User from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        User
    },
    plugins: [createPersistedState()]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js